module.exports = __webpack_public_path__ + "media/images/icon-store-search-active-3f20b93bfb77725c567a82d01fc32734.svg";